var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 50,
    viewBox: "0 0 70 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.7719 12.3454C40.9881 11.1262 41.7406 9.44383 41.7406 7.5851C41.7406 3.86264 38.7226 0.844696 35.0001 0.844696C32.6467 0.844696 30.5777 2.05287 29.372 3.88062C29.0517 4.2014 2.21949 37.2729 1.96866 37.6531C0.752489 38.8723 0 40.5551 0 42.4129C0 46.1358 3.01794 49.1538 6.7404 49.1538C9.0938 49.1538 11.1629 47.9461 12.3686 46.1178C12.6889 45.7971 39.5211 12.7251 39.7719 12.3454Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2974 28.0393C56.5171 26.8192 57.271 25.1348 57.271 23.2736C57.271 19.5511 54.2531 16.5332 50.5306 16.5332C48.1762 16.5332 46.1061 17.7423 44.9005 19.5716C44.5777 19.8949 30.4848 37.2665 30.2325 37.6493C29.0128 38.8695 28.2588 40.5538 28.2588 42.4145C28.2588 46.1375 31.2767 49.1555 34.9992 49.1555C37.3536 49.1555 39.4237 47.9463 40.6289 46.117C40.9517 45.7942 55.0451 28.4221 55.2974 28.0393Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0002 7.5851C70.0002 11.3081 66.9822 14.3255 63.2598 14.3255C59.5368 14.3255 56.5193 11.3081 56.5193 7.5851C56.5193 3.86264 59.5368 0.844696 63.2598 0.844696C66.9822 0.844696 70.0002 3.86264 70.0002 7.5851Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4808 7.5851C13.4808 11.3081 10.4629 14.3255 6.7404 14.3255C3.01794 14.3255 0 11.3081 0 7.5851C0 3.86264 3.01794 0.844696 6.7404 0.844696C10.4629 0.844696 13.4808 3.86264 13.4808 7.5851Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.42149fbde6b254bfc03a622cbe158783.svg";
export { ForwardRef as ReactComponent };